import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, AccountingReport } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseTotalRevenueProps {
  paymentDateStart: string | null;
  paymentDateEnd: string | null;
  productType?: string | null;
  billingSources?: string[];
  paymentMethods?: string[];
  enabled?: boolean;
}

function useTotalRevenue({
  paymentDateStart,
  paymentDateEnd,
  productType,
  billingSources,
  paymentMethods,
  enabled = true,
}: IUseTotalRevenueProps): UseQueryResult<{ data: AccountingReport }> {
  const params: UrlParams = {};

  if (paymentDateStart !== null) {
    params.start_date = paymentDateStart;
  }
  if (paymentDateEnd !== null) {
    params.end_date = paymentDateEnd;
  }
  if (productType !== undefined && productType !== null) {
    params.product_type = productType;
  }
  if (billingSources !== undefined && billingSources.length > 0) {
    params.billing_sources = billingSources.join(',');
  }
  if (paymentMethods !== undefined && paymentMethods.length > 0) {
    params.payment_methods = paymentMethods.join(',');
  }

  return useQuery(
    ['total-revenue', paymentDateStart, paymentDateEnd, productType, billingSources, paymentMethods],
    () => client.get(`reports/total-revenue?${encodeUrlParams(params)}`),
    {
      enabled: enabled && paymentDateStart !== null && paymentDateEnd !== null,
      staleTime: 86400000, // 1 day
    },
  );
}

export default useTotalRevenue;
